import z from "zod/v4";

export const AccuracySchema = z.object({
    totalAccuracy: z.number(),
    gamesAccountedFor: z.number(),
    totalGames: z.number(),
});

export type Accuracy = z.infer<typeof AccuracySchema>;
